import { render, staticRenderFns } from "./save_view.vue?vue&type=template&id=2226de6d&scoped=true"
import script from "./save_view.vue?vue&type=script&lang=js"
export * from "./save_view.vue?vue&type=script&lang=js"
import style0 from "./save_view.vue?vue&type=style&index=0&id=2226de6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2226de6d",
  null
  
)

export default component.exports